import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const FileIcon = props =>
  <SvgIcon {...props}>
    <path d="M 14 2 L 6 2 C 4.898438 2 4 2.898438 4 4 L 4 20 C 4 21.101563 4.898438 22 6 22 L 18 22 C 19.101563 22 20 21.101563 20 20 L 20 8 Z M 18.5 9 L 13 9 L 13 3.5 Z" />
  </SvgIcon>



// WEBPACK FOOTER //
// ./src/assets/Icons/FileIcon.js